import { isComponentFor } from 'Shared/resolve-component';
export default (currentPage) => {
    return isComponentFor(currentPage.componentName, "Avensia.Shop.Features.Start.Pages.Start.StartPageViewModel");
};
